// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsOverview = {
  title: "アセットセンター",
  subtitle: "プラットフォーム統一アセット領域の現在の統治ビューです。",
  menu: {
    governance: "統治ビュー",
    objectSpaces: "オブジェクト空間",
    references: "参照関係",
    mySpace: "マイスペース",
  },
  login: {
    pageTitle: "{platformName} ・ アセットセンター",
    maintenanceNotice:
      "アセットセンターはメンテナンス中です。一部機能が利用できない場合があります。",
    noAccess: "現在の統合認証にはアセットセンターへのアクセス権がありません。",
  },
  directRead:
    "このページは asset-center のアセット主データとオブジェクト空間統治情報を直接参照しています。",
  indirectRead:
    "現在のセッションは統合認証ではありません。このページは連携状態のみ表示し、統合認証ログイン後に主データを直接参照できます。",
  summaryProvider: "アセット提供元: {value}",
  summaryMode: "読取モード: {value}",
  summaryAssets: "総アセット数: {count}",
  summaryInUse: "使用中: {count}",
  governanceReadRestricted:
    "このアカウントはアセット主データを参照できます。オブジェクト空間と参照統治サマリーはアセット管理者のみ表示できます。",
  summarySpaces: "オブジェクト空間: {count}",
  summaryManagedSpaces: "統治空間: {count}",
  summaryBlockedDeleteAssets: "削除阻止資産: {count}",
  summaryPendingUploads: "保留アップロード: {count}",
  summarySize: "総容量: {value}",
  legend: {
    provider: "アセット提供元",
    mode: "読取モード",
    assets: "総アセット数",
    inUse: "使用中",
    spaces: "オブジェクト空間",
    managedSpaces: "統治空間",
    blockedDeleteAssets: "削除阻止資産",
    pendingUploads: "保留アップロード",
    remediation: "是正項目",
    remediationCritical: "重大是正項目",
    size: "総容量",
    mySpaceUsed: "使用量",
    mySpaceQuota: "容量上限",
    mySpaceRemaining: "残容量",
    mySpaceFiles: "ファイル数",
    publicBrandingUsed: "ブランド資源の使用量",
    publicBrandingQuota: "ブランド資源の容量上限",
    publicBrandingRemaining: "ブランド資源の残容量",
    publicBrandingFiles: "ブランド資源ファイル数",
    mySharedFiles: "公開へ共有済み",
    publicSharedFiles: "公開共有ファイル",
    publicSharedActive: "共有中",
  },
  directMode: "センター直読",
  indirectMode: "連携状態",
  providerLabel: "現在の提供元: {value}",
  centerBaseUrl: "アセットセンター URL: {value}",
  openCenter: "アセットセンターを開く",
  openExamAssets: "試験アセット画面を開く",
  cards: {
    access: "接続情報",
    controlPlane: "制御面概要",
    mySpace: "マイスペース",
    fullAccessEndpoints: "完全なアクセス端点",
    rawConfigJson: "生の config_json",
    rawRuntimeJson: "生の runtime_json",
  },
  controlPlaneFields: {
    managedSpaces: "統治空間",
    readonlySpaces: "読取専用空間",
    disabledSpaces: "停止空間",
    spacesWithoutGrants: "未許可空間",
    referenceBindings: "参照バインド",
    blockedDeleteAssets: "削除阻止資産",
    pendingUploads: "保留アップロード",
    uploadedRequests: "アップロード済み要求",
    readyRequests: "完了待ち要求",
    failedRequests: "失敗要求",
    governedSpaces: "正常統治空間",
    warningSpaces: "警告空間",
    blockedSpaces: "阻止空間",
    unmanagedSpaces: "未統治空間",
    applicationGrants: "アプリ権限",
    userGrants: "ユーザー権限",
    referenceServices: "参照サービス数",
    referenceScopes: "参照スコープ数",
    referenceWarningRows: "参照警告件数",
    crossScopeRows: "クロススコープ参照",
    highBindingRows: "高密度参照",
    remediationItems: "是正項目",
    remediationCritical: "重大是正項目",
    remediationObjectSpaces: "空間是正項目",
    remediationReferences: "参照是正項目",
    remediation: "是正提案",
  },
  tables: {
    spaces: "オブジェクト空間",
    spacesSubtitle:
      "オブジェクト空間はアセットのオブジェクトキー接頭辞で集約され、帰属・容量・統治方針を確認できます。",
    latestAssets: "最新アセット",
    latestAssetsSubtitle:
      "asset-center の最新アセットを直接読み、プラットフォーム棚卸しと統治確認に利用します。",
    refs: "業務横断参照カタログ",
    refsSubtitle: "asset-center が受け付けている業務横断の参照口径をここで確認します。",
  },
  tabs: {
    governance: "統治ビュー",
    references: "参照関係",
    mySpace: "マイスペース",
  },
} as const;
